import { Action, State } from "./types";

export const ConciergeFilterReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_SELECTED_VALUE":
      return { ...state, selectedValue: action.payload };
    case "SET_LAST_SELECTED_DIVISION": 
      return { ...state, lastSelectedDivision: action.payload };
    case "SET_FILTERED_DATA":
      return { ...state, filteredData: action.payload };
    default:
      return state;
  }
};